module.exports = __webpack_public_path__ + "media/images/Summa-3d1d40985770f9ddf616ae8af7c0488c.png";